
import { INotice, NoticePriority } from '@/store/notice-store';
import { Component, Prop, Vue } from "vue-property-decorator";
import NoticePassengers from '@/components/Notices/NoticePassengers.vue';

@Component({
  components: {
    NoticePassengers,
  },
})
export default class NoticeTitle extends Vue {
  @Prop({ required: true }) notice!: INotice;
  @Prop({ required: true }) titleId!: string;

  get isSticky() {
    return this.notice.priority === NoticePriority.Sticky;
  }

  get targetPassengersLabel() {
    return `${this.$t('notices.notice')}: ${this.$t('menu.passengers')}`;
  }

  get validityPeriod() {
    let start = null;
    let end = null;
    if (this.notice?.validFrom) {
      start = this.$options.filters?.date(this.notice.validFrom);
    }
    if (this.notice?.validUntil) {
      end = this.$options.filters?.date(this.notice.validUntil);
    }

    return [start, end].filter(Boolean).join(' - ');
  }

}

